module.exports = __webpack_public_path__ + "static/media/booking-logo.95e6fb1c.png";